/**
 * Maps known English API error strings to ui translations (OTP cooldown, login fallbacks, etc.).
 */
export function mapAuthApiErrorMessage(message, t) {
  if (message == null || typeof message !== 'string') return message;
  const trimmed = message.trim();
  if (
    trimmed === 'Please wait before requesting another OTP' ||
    /^please wait before requesting another otp\.?$/i.test(trimmed)
  ) {
    return t('customerAuth.errOtpWaitBeforeAnother');
  }
  // AuthContext fallbacks (must be translated — raw English was shown in LoginScreen)
  if (trimmed === 'Login failed' || /^login failed$/i.test(trimmed)) {
    return t('auth.loginFailed');
  }
  const statusMatch = /^Login failed with status:\s*(\d+)$/i.exec(trimmed);
  if (statusMatch) {
    return t('auth.loginFailedWithStatus', { status: statusMatch[1] });
  }
  if (trimmed === 'Invalid response format from server') {
    return t('auth.invalidServerResponse');
  }
  if (trimmed === 'Network error occurred') {
    return t('backendErrors.network');
  }
  return message;
}
